import { FC } from 'react';
import styled from 'styled-components';
import ButtonChart, { Chart } from './ButtonChart';

const Button = styled.button(({ theme }) => {
  const { color, shadow, type } = theme;

  return `
    position: relative;
    background-color: ${color.grayscale[1000]};
    border-radius: 16px;
    box-shadow: ${shadow.regular};
    padding: 24px 1rem;
    font-size: ${type.size.small};
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    font-weight: ${type.weight.bold};
    line-height: 1.375;
    cursor: pointer;

    @media (prefers-reduced-motion: no-preference) {
      transition: all 150ms ease-in-out;
    }

    &:hover:not(:active) {
      box-shadow: ${shadow.hover};
      transform: scale(1.025, 1.025);
    }

    &:hover:active {
      box-shadow: ${shadow.active};
      transform: scale (1.0125, 1.0125);

      @media (prefers-reduced-motion: no-preference) {
        transition: all 25ms ease-in-out;
      }
    }
  `;
});

export interface IPlayerChartCard {
  measurementData: {
    display_name: string;
    measurement_id: string;
    data: Chart[];
  };
  clickCallback: (measurement_id: string) => void;
}

const PlayerChartCard: FC<IPlayerChartCard> = ({ measurementData, clickCallback }) => {
  const { measurement_id, display_name, data } = measurementData;

  return (
    <Button type="button" onClick={() => clickCallback(measurement_id)}>
      <ButtonChart display_name={display_name} chartData={data} />
    </Button>
  );
};

export default PlayerChartCard;
